import { render, staticRenderFns } from "./CargaMultasExcel.vue?vue&type=template&id=553727d8&scoped=true"
import script from "./CargaMultasExcel.vue?vue&type=script&lang=js"
export * from "./CargaMultasExcel.vue?vue&type=script&lang=js"
import style0 from "./CargaMultasExcel.vue?vue&type=style&index=0&id=553727d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553727d8",
  null
  
)

export default component.exports